import React from 'react';
import { Payment } from '../../types/Payment';
import '../../css/modal.css';

interface PaymentHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  payments: Payment[];
  total: number;
  loading?: boolean;
}

const PaymentHistoryModal: React.FC<PaymentHistoryModalProps> = ({ isOpen, onClose, payments, total, loading = false }) => {
  if (!isOpen) return null;

  const paid = payments.reduce((sum, p) => sum + (parseFloat(String(p.amount)) || 0), 0);
  const balance = total - paid;

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h3>Payment History</h3>
        <p><strong>Total:</strong> ₹{total.toLocaleString('en-IN')}</p>
        <p><strong>Paid:</strong> ₹{paid.toLocaleString('en-IN')}</p>
        <p><strong>Balance:</strong> ₹{balance.toLocaleString('en-IN')}</p>

        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>Loading payment history...</div>
        ) : (
          <table className="payment-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Amount</th>
                <th>Method</th>
                <th>Transaction ID</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {payments.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: 'center', padding: '20px' }}>No payment history found</td>
                </tr>
              ) : (
                payments.map(p => {
                  // Handle amount - if it's already in rupees, use it; if in paisa, convert
                  const amount = typeof p.amount === 'string' 
                    ? Number(p.amount) / 100 
                    : (p.amount || 0);
                  const transactionId = (p as any).transactionId || (p as any).transaction_id || (p as any).notes?.transactionId || '-';
                  
                  return (
                    <tr key={p.id}>
                      <td>{p.created_at ? new Date(p.created_at).toLocaleDateString() : '-'}</td>
                      <td>₹{amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td>{p.method || '-'}</td>
                      <td>{transactionId}</td>
                      <td>{p.status || '-'}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        )}

        <button className="close-btn" onClick={onClose}>×</button>
      </div>
    </div>
  );
};

export default PaymentHistoryModal;
